import { Type, type Static } from '@sinclair/typebox';
import { DraftTypes } from '../enums.js';
import { RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

const DraftTypeSchema = Type.Union(DraftTypes.map((t) => Type.Literal(t)));
const DraftPayloadSchema = Type.Record(Type.String(), Type.Any());

export const DraftSchema = Type.Object({
  id: UuidSchema,
  draftType: DraftTypeSchema,
  projectId: Type.Union([UuidSchema, Type.Null()]),
  entityId: Type.Union([UuidSchema, Type.Null()]),
  payloadJson: DraftPayloadSchema,
  createdByUserId: UuidSchema,
  updatedByUserId: UuidSchema,
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type Draft = Static<typeof DraftSchema>;

export const DraftSaveSchema = Type.Object({
  draftType: DraftTypeSchema,
  projectId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  entityId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  payloadJson: DraftPayloadSchema,
});
export type DraftSave = Static<typeof DraftSaveSchema>;

export const DraftListQuerySchema = Type.Object({
  draftType: Type.Optional(DraftTypeSchema),
  projectId: Type.Optional(UuidSchema),
  entityId: Type.Optional(UuidSchema),
  includeDeleted: Type.Optional(Type.Boolean({ default: false })),
  page: Type.Optional(Type.Integer({ minimum: 1, default: 1 })),
  pageSize: Type.Optional(Type.Integer({ minimum: 1, maximum: 200, default: 50 })),
});
export type DraftListQuery = Static<typeof DraftListQuerySchema>;
